import script from "./formTutorialAjuda.vue?vue&type=script&setup=true&lang=js"
export * from "./formTutorialAjuda.vue?vue&type=script&setup=true&lang=js"

import "./formTutorialAjuda.vue?vue&type=style&index=0&id=20bd6011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bd6011"]])

export default __exports__